// =============================================================================
// Contact Forms
// =============================================================================

$('document').ready(() => {

    if ( $('body').hasClass('page-id-538') || $('body').hasClass('page-id-452')) { // Live = 538; Dev = 452
        const $body = $('html, body');
        const $ft = $('.component--form').offset().top;

        $body.animate({scrollTop: $ft },1500);
        $('.component--form input[name="client-name"]').focus();


    }

    if ($('#enquiry-type').length){
        $('#enquiry-type').prepend('<option value="">Enquiry Type (required)</option').val("").trigger("change");
    }

    if ($('#department').length){
        $('#department').prepend('<option value="">What department would you like to speak to? (required)</option').val("").trigger("change");
    }


    const dropdownstyle = type => {
        return event => {

            if ($(event.target).val() == "")
                $(event.target).addClass("placeholder");
            else
                $(event.target).removeClass("placeholder");
        }
    };

    $('.wpcf7-form select').on('change', dropdownstyle());


    const closeBrochureModal = type => {
        return event => {
            event.preventDefault();
            $('.modal-brochure').css('opacity',0);
            setTimeout(function(){
                $('.modal-brochure').hide();
            }, 1000)
        }
    };

    const openBrochureModal = type => {
        return event => {
            window.location.href = "/contact-us";

            // event.preventDefault();
            // $('.modal-brochure').show();
            // setTimeout(function(){
            //     $('.modal-brochure').css('opacity',1);
            // }, 250)
        }
    };

    $('.modal-close-button').on('click', closeBrochureModal());

    $('[href="#brochure"]').on('click', openBrochureModal());

    var showModal = true;

    // if ($('.modal-brochure').hasClass('show-on-scroll')) {
    //     $(window).scroll(function () { 
    //         if ($(window).scrollTop() > $('body').height() / 2 && showModal) {
    //             $('.modal-brochure').show();
    //             setTimeout(function(){
    //                 $('.modal-brochure').css('opacity',1);
    //             }, 250)
    //             showModal = false;
    //         } 
    //     });
    // }

});



// WEBPACK FOOTER //
// ./public/themes/masuri/assets/js/library/ContactForms.js